// extracted by mini-css-extract-plugin
export var container = "_gz-1";
export var cornerButtonContainer = "_gz-6";
export var disabled = "_gz-2";
export var dragActive = "_gz-3";
export var fileContainer = "_gz-5";
export var hiddenInput = "_gz-4";
export var widthContainer = "_gz-0";